import { createApp } from 'vue'
import App from './App.vue'
import Particles from 'vue3-particles'

import { registerSW } from 'virtual:pwa-register'

const applyInitialTheme = () => {
    const savedTheme = localStorage.getItem('theme')
    const initialTheme = savedTheme || 'dark'
    document.documentElement.setAttribute('data-theme', initialTheme)
}
applyInitialTheme()

const toggleTheme = () => {
    const currentTheme = document.documentElement.getAttribute('data-theme')
    const newTheme = currentTheme === 'light' ? 'dark' : 'light'
    document.documentElement.setAttribute('data-theme', newTheme)
    localStorage.setItem('theme', newTheme)
    window.dispatchEvent(new Event('themeChanged'))
}

const app = createApp(App)

// Register the service worker with update callbacks
if ('serviceWorker' in navigator) {
    registerSW({
        onNeedRefresh() {
            localStorage.setItem('sw-update', date.now())
            const updateConfirmed = confirm('New version available! Refresh now?')
            if (updateConfirmed) {
                console.log('update confirmed')
                // window.location.reload()
            }
        },
        onOfflineReady() {
            console.log('App is ready for offline use.')
        }
    })
}

window.addEventListener('storage', (event) => {
    if (event.key === 'sw-update') {
        // This event fires in tabs other than the one that triggered the change
        const updateConfirmed = confirm('New version available in another tab! Refresh now?')
        if (updateConfirmed) {
            console.log('update confirmed')
            // window.location.reload()
        }
    }
})

app.config.globalProperties.$toggleTheme = toggleTheme

app.config.globalProperties.getValue = function (key) {
    if (typeof Storage !== 'undefined') {
        var post = localStorage.getItem(key)
        if (post === 'undefined') {
            return ''
        }
        return post
    } else {
        return this.getCookie(key)
    }
}

async function bootstrap() {
    try {
        app.use(Particles)

        console.log('Initialization complete. Mounting the app...')
        app.mount('#app')
        console.log('App mounted successfully!')

    } catch (error) {
        console.error('Error during app initialization:', error)
    }
}

bootstrap()